import { openFlexPane } from 'owa-suite-header-apis';

export function toggleTimePanel() {
    openFlexPane('OwaTimePanel');
}
